var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'cursor-pointer color-dot ' + _vm.classes,on:{"click":(e) => _vm.$emit('click', e)}},[_c('div',{style:(`background-color:${_vm.hex}`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }